var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M473.655,88.275H256v335.448h217.655c21.177,0,38.345-17.167,38.345-38.345V126.62 C512,105.442,494.833,88.275,473.655,88.275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M38.345,88.275C17.167,88.275,0,105.442,0,126.62V385.38c0,21.177,17.167,38.345,38.345,38.345H256 V88.275H38.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M73.564,108.873v23.62c1.301,0.051,2.752,0.641,3.958,1.847s1.798,2.657,1.847,3.958h23.62v23.54 H79.368c-0.051,1.301-0.641,2.752-1.847,3.958s-2.657,1.796-3.958,1.847v23.62h-23.54v-23.62c-1.301-0.051-2.752-0.641-3.958-1.847 s-1.796-2.657-1.847-3.958h-23.62v-23.539h23.62c0.051-1.301,0.641-2.752,1.847-3.958s2.657-1.796,3.958-1.847v-23.62h23.541  M76.505,105.93h-2.943h-23.54H47.08v2.943v21.303c-1.123,0.46-2.177,1.165-3.096,2.083c-0.919,0.919-1.623,1.973-2.084,3.096 H20.598h-2.943v2.943v23.54v2.943h2.943h21.303c0.461,1.123,1.165,2.178,2.084,3.096c0.918,0.918,1.972,1.623,3.095,2.083v21.303 v2.942h2.943h23.54h2.943v-2.943v-21.303c1.123-0.46,2.177-1.165,3.096-2.084c0.918-0.918,1.623-1.972,2.083-3.095h21.303h2.942 v-2.943v-23.54v-2.943h-2.943H81.686c-0.46-1.123-1.165-2.177-2.084-3.096c-0.918-0.918-1.972-1.623-3.096-2.083v-21.302 L76.505,105.93L76.505,105.93z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDCDCD"
    },
    points: "102.988,138.298 73.564,138.298 73.564,108.873 50.023,108.873 50.023,138.298  20.598,138.298 20.598,161.839 50.023,161.839 50.023,191.264 73.564,191.264 73.564,161.839 102.988,161.839 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B4A08C"
    },
    cx: 61.793,
    cy: 150.07,
    r: 11.77
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -32.3419 313.0133)",
    style: {
      fill: "#B4A08C"
    },
    cx: 48.656,
    cy: 163.205,
    rx: 5.234,
    ry: 3.663
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -93.4504 100.7866)",
    style: {
      fill: "#B4A08C"
    },
    cx: 74.935,
    cy: 163.198,
    rx: 5.234,
    ry: 3.663
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 118.773 -12.8703)",
    style: {
      fill: "#B4A08C"
    },
    cx: 74.922,
    cy: 136.937,
    rx: 5.234,
    ry: 3.663
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 179.8755 199.3536)",
    style: {
      fill: "#B4A08C"
    },
    cx: 48.65,
    cy: 136.93,
    rx: 5.234,
    ry: 3.663
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B4A08C"
    },
    d: "M61.793,166.182c-8.885,0-16.113-7.226-16.113-16.113s7.228-16.113,16.113-16.113 s16.113,7.228,16.113,16.113C77.906,158.953,70.678,166.182,61.793,166.182z M61.793,135.427c-8.072,0-14.641,6.569-14.641,14.641 s6.569,14.641,14.641,14.641s14.641-6.569,14.641-14.641S69.865,135.427,61.793,135.427z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMt);
export default __webpack_public_path__ + "static/media/mt.d445c3a785453772ec115fa818bbef9b.svg";
export { ForwardRef as ReactComponent };